import { render, staticRenderFns } from "./LinkProjectModal.vue?vue&type=template&id=10859552"
import script from "./LinkProjectModal.vue?vue&type=script&lang=js"
export * from "./LinkProjectModal.vue?vue&type=script&lang=js"
import style0 from "./LinkProjectModal.vue?vue&type=style&index=0&id=10859552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports